import Navbar from 'components/Navbar/Navbar'
import styles from './styles.module.scss'
import AdminLayout from './AdminLayout'
import CounselorLayout from './CounselorLayout'
import { ROLES } from 'utils/constants'

const Layout = ({ role, children }) => {
  if (role === ROLES.DOCTOR) {
    return (
      <div className={styles.root}>
        <Navbar />
        {children}
      </div>
    )
  }

  if (role === ROLES.ADMIN) {
    return <AdminLayout role={role}>{children}</AdminLayout>
  }

  if (role === ROLES.COUNSELOR) {
    return <CounselorLayout role={role}>{children}</CounselorLayout>
  }

  return <>{children}</>
}

export default Layout
